module.exports = __webpack_public_path__ + "h5/img/yuanxin.b159e356.png";